export enum StatusProcessoEnum {
    NAO_ENCAMINHADA = 0,
    ENVIADA = 1,
    EM_ACOMPANHAMENTO = 2,
    RETOMADA = 3,
    FINALIZADA = 4
}
